import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const title: CSSObject = {
  fontSize: 15,
  fontWeight: 600,
  lineHeight: 1.4,
  color: theme.color.text,
  wordBreak: 'break-all',
};

export { title };
